// Default menu names (fixed initial values)
// Each element is [line1, line2] format (max 10 chars per line)
// 5 items for 5 product types
// Note: Product names (coffee, ole, tea, cola, apple) are appended

export const DEFAULT_MENU_NAMES: string[][] = [
  ['これからもずっと', '仲良くしてね'],
  ['これからもずっと', '友だちでいてね'],
  ['生まれてきてくれて', 'ありがとう'],
  ['あなたをお祝いする', '祝杯の'],
  ['これからも', '応援してるよ'],
]

/**
 * Get default menu names
 * @returns Array of 5 menu item names, each as [line1, line2]
 */
export function getDefaultMenuNames(): string[][] {
  return DEFAULT_MENU_NAMES
}
